import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";

import {
    storeCustomerTicket,
    setDateTimeDeliveryModeSale,
    orchestratorStore as store,
} from "@components/Common/PrinterSetting/stores";
import type { ModeOfSaleRow } from "@components/Common/PrinterSetting/stores";

import "../index.css";

export default function PrintCustomer() {
    const { t } = useTranslation();
    const { dateTimeDeliveryModeSale } = useSnapshot(storeCustomerTicket);
    const { salesModes } = useSnapshot(store);

    useEffect(() => {
        setDateTimeDeliveryModeSale([...(salesModes.customerTicket ?? [])]);
    }, [salesModes.customerTicket]);

    const handleStateSortedVisibilityChange = (
        item: ModeOfSaleRow,
        key: number
    ) => {
        const items = { ...item };
        items.state = !items.state;
        const newVisibility: ModeOfSaleRow[] = JSON.parse(
            JSON.stringify(dateTimeDeliveryModeSale)
        );
        newVisibility[key].state = items.state;
        setDateTimeDeliveryModeSale(newVisibility);
    };
    return (
        <div>
            <div className="d-flex px-2 pb-1 pt-2">
                <div>
                    <b>
                        {t(
                            "Print the customer's address according to the mode of sale"
                        )}
                    </b>
                </div>
            </div>
            <div className="d-flex  align-items-center d-flex flex-wrap">
                {dateTimeDeliveryModeSale !== undefined
                    ? dateTimeDeliveryModeSale.map(
                          (
                              modeOfSale: ModeOfSaleRow,
                              index: number
                          ): JSX.Element => (
                              <div
                                  key={modeOfSale.designation}
                                  className="text-danger row b-2 align-items-center"
                              >
                                  <div
                                      className="d-flex col-4"
                                      style={{ color: "#212529 " }}
                                  >
                                      <div className="px-1">
                                          <h6 style={{ width: "87px" }}>
                                              {t(modeOfSale.designation)}
                                          </h6>
                                      </div>
                                      <div className="mr-2">
                                          <ReactSwitch
                                              uncheckedIcon={false}
                                              checkedIcon={false}
                                              handleDiameter={26}
                                              offColor="#f7b4b8"
                                              offHandleColor="#E30613"
                                              checked={modeOfSale.state}
                                              onChange={() => {
                                                  handleStateSortedVisibilityChange(
                                                      modeOfSale,
                                                      index
                                                  );
                                              }}
                                              onColor="#c2eddd"
                                              onHandleColor="#34C38F"
                                              width={55}
                                              height={20}
                                              className="afa_icn_printAddressAccordingModeOfSale"
                                              aria-label={t(
                                                  modeOfSale.designation
                                              )}
                                              data-testid={`printer-setting-customer-address-mode-${index}-switch`}
                                          />
                                      </div>
                                  </div>
                              </div>
                          )
                      )
                    : null}
            </div>
        </div>
    );
}
